module.exports = __webpack_public_path__ + "img/icon-fullscreen.b6c8ba9f.svg";